import { AxiosRestApplicationClient as OnboardingAxiosRestApplicationClient } from '@g2-shared/api-client/generated/onboarding-app';
import {
  getServerErrorMessage,
  LoggingServiceAdapter,
  NotificationAdapter,
} from '@g2-shared/common';
import { generateBaseAxiosClient } from '@g2-shared/common/libs/baseAxiosClient';

/* -------------- */
/*    CURRENCY    */
/* -------------- */
export const FIND_PARTIES = 'FIND_PARTIES';
export const FIND_PARTY_BY_ID = 'FIND_PARTY_BY_ID';
export const FIND_PARTY_BY_SELF_USER = 'FIND_PARTY_BY_SELF_USER';
export const FIND_PARTIES_FOR_AGENT = 'FIND_PARTIES_FOR_AGENT';

export const partyApiDefaultConfig = {
  retry: undefined,
  // cacheTime: Infinity,
};

export const usePartyApiDefaultConfig = (callerName: string) => {
  const { logError } = LoggingServiceAdapter();
  const { translateAndNotifyError } = NotificationAdapter();

  return {
    ...partyApiDefaultConfig,
    onError: (error: unknown) => {
      translateAndNotifyError(getServerErrorMessage(error));
      logError(error, 'Error while calling party api', callerName);
    },
  };
};

/* -------------- */
/*      AXIOS     */
/* -------------- */

const { VITE_APP_GATEWAY_BASE_URL } = import.meta.env;

export const onboardingAxiosClient = new OnboardingAxiosRestApplicationClient(
  VITE_APP_GATEWAY_BASE_URL,
  generateBaseAxiosClient({ baseURL: VITE_APP_GATEWAY_BASE_URL })
);
